import React, { useState } from "react";
import Headerdash from "../pages/head";
import Sidebar from "../pages/sidebar";

export default function UpgradeYourPlan({ role }) {
    let message;

    switch(role) {
      case 7:
        message = "Plan Expired or No Plan Selected";
        break;
      case 5:
      case 6:
        message = "Upgrade Your Plan to Premium";
        break;
      default:
        message = "No Plan";
    }
  return (
    <div>
      <Headerdash />
      <Sidebar />

      <div className="relative md:left-[293px] h-screen md:w-4/5">
  {/* Blurred background */}
  <div className="absolute inset-0 bg-gray-300 bg-opacity-30 backdrop-blur-sm"></div>
  
  {/* Message box */}
  <div className="relative flex items-center justify-center h-full">
    <div className="p-4 bg-white rounded-md shadow-xl text-center">
      <h1 className="text-2xl font-bold text-gray-900">
        {message}
      </h1>
    </div>
  </div>
</div>

    </div>
  );
}
